import React, { useState } from 'react';
import { Icon } from '../../concepts/resources/Icon';
import { TableButtonProps } from '../../ui/TableButton';
import { Popover } from '../canvas/ui/Popover';
import { AvatarStripItem } from './AvatarStrip';
import { AvatarTableButton } from './AvatarTableButton';
import { SelectUserView } from './SelectUserView';

export type SelectUserTableButtonProps = Omit<TableButtonProps, 'active'> & {
    value?: AvatarStripItem,
    placeholder?: string,
    onChange?: (next: AvatarStripItem) => void,
};

export const SelectUserTableButton = ({ disabled, variant, value, placeholder, onChange }: SelectUserTableButtonProps) => {

    const [open, setOpen] = useState(false);

    const onSelect = (user: AvatarStripItem) => {
        onChange?.(user);
        setOpen(false);
    };

    return <Popover
        placement="bottom-end"
        content={<SelectUserView allowKeyboard allowSearch {...{ title: 'Assign Action To...', onSelect }} />}
        inner={{ direction: 'down' }}
        open={open}
        onOpenChange={setOpen}
        disabled={disabled}
    >
        <AvatarTableButton active={open} variant={variant} value={value} placeholder={placeholder}>
            {!disabled && <Icon size="1.25" src="deqo://icons/hero-mini/chevron-down" />}
        </AvatarTableButton>
    </Popover>;
};
